var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.as,{tag:"component",staticClass:"z-table-cell flex-1 px-5 py-2.5"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }